export default "__VITE_ASSET__DdFXeRzb__"